module.exports = __webpack_public_path__ + "static/media/clockIcon.679efec0.svg";